(function(){
if (window.__blCart) return; window.__blCart = true;
var root = document.getElementById('bl-cd');
var body = document.getElementById('bl-cd-body');
var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var SEC = 'bl-cart-drawer';
var data = null, hideSub = {}, kbMap = {};
var BADGE = {'Dad Mom Bundle':'Dad & Mom Bundle'};
var BD=window.BlDeal, deals=BD.deals, loadDeal=BD.load, nextBar=BD.next, barOf=BD.bar, rid=BD.rid;
function upgrade(key){
var it=(data.items||[]).filter(function(i){return i.key===key;})[0]; if(!it)return;
var d=deals[it.pid], b=nextBar(d,it.qty); if(!b)return;
var id=rid(), items=[{id:it.vid,quantity:b.qty,properties:{__kaching_bundles:JSON.stringify({deal:d.nano,pp:Number(d.pid),main:true,v:d.ver,id:id,bid:b.id})}}];
b.gifts.forEach(function(g){var vid=d.gv[g.pid];if(vid)items.push({id:vid,quantity:g.qty,properties:{__kaching_bundles:JSON.stringify({id:id,deal:d.nano,v:d.ver,gift:g.id})}});});
busy(true);
var u={};u[key]=0;
fetch(R+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:u})})
.then(function(){return fetch(R+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});})
.then(function(){return refresh();}).finally(function(){busy(false);});
}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function readData(){var s=document.getElementById('bl-cd-data');try{data=JSON.parse(s.textContent);}catch(e){data={items:[],ups:[],count:0,total:0,fmt:'$1,234.56'};}}
function money(c){
var f=(data&&data.fmt)||'$1,234.56', m=f.match(/1(\D?)234(\D?)56/);
if(!m){return (c/100).toFixed(2);}
var pre=f.slice(0,m.index), suf=f.slice(m.index+m[0].length), th=m[1], ds=m[2];
var v=(Math.abs(c)/100).toFixed(2).split('.'), i=v[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);
return (c<0?'-':'')+pre+i+(ds?ds+v[1]:'')+suf;
}
function pct(oldp,fin){if(!oldp||oldp<=fin)return 0;return Math.round((1-fin/oldp)*100);}
var TRASH='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';
var TAG='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
var CHEV='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 15 6-6 6 6"/></svg>';
function priceBlock(oldp, fin, keys, free){
var s=pct(oldp,fin);
return '<div class="bl-cd__right">'+
(oldp>fin?'<span class="bl-cd__old">'+money(oldp)+'</span>':'')+
'<span class="bl-cd__fin">'+(free?'FREE':money(fin))+'</span>'+
(s>0?'<span class="bl-cd__save">You save '+s+'%</span>':'')+
(keys?'<button type="button" class="bl-cd__rm" data-bl-rm="'+esc(keys)+'" aria-label="Remove">'+TRASH+'</button>':'')+
'</div>';
}
function img(it){return '<div class="bl-cd__img">'+(it.img?'<img src="'+esc(it.img)+'" alt="" loading="lazy">':'')+'</div>';}
function oldOf(it){return Math.max(it.cmp||0,it.orig||0);}
function render(){
readData();
var items=data.items||[];
updateBubble(data.count);
if(!items.length){
body.innerHTML='<div class="bl-cd__empty"><p>Your cart is empty</p><button type="button" data-bl-close>Continue shopping</button></div>';
return;
}
var groups=[], byId={};
items.forEach(function(it){
var kb=null, ks=kbMap[it.key]||it.kb; try{kb=ks?JSON.parse(ks):null;}catch(e){}
if(kb&&kb.id&&!kb.gift){var bb=barOf(deals[it.pid],kb.bid);if(bb&&bb.qty===1&&!(bb.dv>0)&&!bb.gifts.length)kb=null;}
if(kb&&kb.id){
var g=byId[kb.id];
if(!g){g=byId[kb.id]={id:kb.id,main:[],gifts:[]};groups.push(g);}
(kb.gift?g.gifts:g.main).push(it);
} else groups.push({single:it});
});
var h='', needDeals=[];
groups.forEach(function(g){
if(g.single){
var it=g.single, dl=deals[it.pid], nb=nextBar(dl,it.qty);
if(dl===undefined&&it.pid){needDeals.push(it);}
var tip='';
if(nb){var need=nb.qty-it.qty, parts=[];if(nb.dv>0)parts.push(nb.dt==='percentage'?nb.dv+'% off':money(nb.dv*100)+' off');if(nb.gifts.length)parts.push(nb.gifts.length>1?'free gifts':'free gift');tip='<button type="button" class="bl-cd__tip" data-bl-up="'+esc(it.key)+'"><span>Add '+need+' more to get '+parts.join(' + ')+'</span></button>';}
h+='<div class="bl-cd__line">'+img(it)+'<div class="bl-cd__info"><a class="bl-cd__title" href="'+esc(it.url)+'">'+esc(it.pt)+'</a>'+
(it.vt?'<span class="bl-cd__var">'+(it.opt?esc(it.opt)+':<br>':'')+esc(it.vt)+'</span>':'')+
(dl?'':'<div class="bl-cd__qty"><button type="button" data-bl-q="'+esc(it.key)+'" data-n="'+(it.qty-1)+'" aria-label="Decrease">&minus;</button><span>'+it.qty+'</span><button type="button" data-bl-q="'+esc(it.key)+'" data-n="'+(it.qty+1)+'" aria-label="Increase">+</button></div>')+
tip+'</div>'+priceBlock(oldOf(it),it.fin,it.key,it.fin===0&&it.orig>0)+'</div>';
return;
}
var keys=g.main.concat(g.gifts).map(function(i){return i.key;}).join(',');
var hh='<div class="bl-cd__grp">';
if(g.main.length){
var q=0,o=0,f=0,first=g.main[0],same=true;
g.main.forEach(function(i){q+=i.qty;o+=oldOf(i);f+=i.fin;if(i.pt!==first.pt)same=false;});
var title=q+'x '+(same?first.pt:'Bundle');
var fkb=null;try{fkb=JSON.parse(kbMap[first.key]||first.kb||'null');}catch(e){}
var fb=fkb&&barOf(deals[first.pid],fkb.bid);
if(deals[first.pid]===undefined&&first.pid)needDeals.push(first);
var badge=fb&&fb.title?fb.title:(first.disc?(BADGE[first.disc]||first.disc):'');
var closed=!!hideSub[g.id];
var multi=q>1||g.main.length>1;
hh+='<div class="bl-cd__line">'+img(first)+'<div class="bl-cd__info"><a class="bl-cd__title" href="'+esc(first.url)+'">'+esc(title)+'</a>'+
(badge?'<span class="bl-cd__badge">'+TAG+esc(badge)+'</span>':'')+
(multi?'<button type="button" class="bl-cd__tog'+(closed?' is-closed':'')+'" data-bl-tog="'+esc(g.id)+'">'+(closed?'Show':'Hide')+' '+q+' items '+CHEV+'</button>'+
'<ul class="bl-cd__sub"'+(closed?' hidden':'')+'>'+g.main.map(function(i){return '<li>'+i.qty+'&times; '+esc(i.vt||i.pt)+'</li>';}).join('')+'</ul>'
:(first.vt?'<span class="bl-cd__var">'+esc(first.vt)+'</span>':''))+
'</div>'+priceBlock(o,f,keys,false)+'</div>';
}
g.gifts.forEach(function(i){
hh+='<div class="bl-cd__line is-gift"><span class="bl-cd__arrow">&#8627;</span>'+img(i)+'<div class="bl-cd__info"><span class="bl-cd__title">'+i.qty+'x '+esc(i.pt)+'</span>'+(i.vt?'<span class="bl-cd__var">'+esc(i.vt)+'</span>':'')+'</div>'+
priceBlock(oldOf(i),i.fin,g.main.length?'':keys,i.fin===0)+'</div>';
});
h+=hh+'</div>';
});
var inCart={}; items.forEach(function(i){inCart[i.vid]=1;});
var ups=(data.ups||[]).filter(function(u){return !inCart[u.vid];});
if(ups.length){
var ARL='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>';
var ARR='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
var slides='';
for(var si=0;si<ups.length;si+=2){
slides+='<div class="bl-cd__slide">'+ups.slice(si,si+2).map(function(u){return '<div class="bl-cd__pi"><div class="bl-cd__pi-img">'+(u.img?'<img src="'+esc(u.img)+'" alt="" loading="lazy">':'')+'</div><div class="bl-cd__pi-c"><a class="bl-cd__pi-t" href="'+esc(u.url)+'">'+esc(u.t)+'</a><div class="bl-cd__pi-p"><span class="bl-cd__pi-f">'+money(u.p)+'</span>'+(u.c>u.p?'<s class="bl-cd__pi-o">'+money(u.c)+'</s>':'')+'</div><button type="button" class="bl-cd__pi-b" data-bl-add="'+u.vid+'">Add to cart</button></div></div>';}).join('')+'</div>';
}
var many=ups.length>2;
h+='<div class="bl-cd__ups"><h3 class="bl-cd__ups-h">Frequently Added Together:</h3><div class="bl-cd__car">'+
(many?'<button type="button" class="bl-cd__arw" data-bl-nav="-1" aria-label="Previous">'+ARL+'</button>':'')+
'<div class="bl-cd__track">'+slides+'</div>'+
(many?'<button type="button" class="bl-cd__arw" data-bl-nav="1" aria-label="Next">'+ARR+'</button>':'')+
'</div></div>';
}
body.innerHTML=h;
navState();
if(needDeals.length){var seen={};Promise.all(needDeals.filter(function(i){if(seen[i.pid])return false;seen[i.pid]=1;return true;}).map(function(i){return loadDeal(i.pid,i.url);})).then(function(){render();});}
}
function navState(){
var t=body.querySelector('.bl-cd__track'); if(!t)return;
var b=body.querySelectorAll('[data-bl-nav]');
if(b.length===2){b[0].disabled=t.scrollLeft<=2;b[1].disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-2;}
}
body.addEventListener('scroll',function(e){if(e.target.classList&&e.target.classList.contains('bl-cd__track'))navState();},true);
function updateBubble(n){
document.querySelectorAll('.cart-bubble').forEach(function(b){b.classList.toggle('visually-hidden',!n);});
document.querySelectorAll('.cart-bubble__text-count').forEach(function(c){c.textContent=n?(n<100?n:''):'';c.classList.toggle('hidden',!n);});
document.querySelectorAll('.header-actions__cart-icon').forEach(function(c){c.classList.toggle('header-actions__cart-icon--has-cart',!!n);});
}
function applySection(html){
if(!html)return;
var doc=new DOMParser().parseFromString(html,'text/html');
var nd=doc.getElementById('bl-cd-dyn'), cur=document.getElementById('bl-cd-dyn');
if(!nd||!cur)return;
cur.innerHTML=nd.innerHTML;
cur.querySelectorAll('script:not([type="application/json"])').forEach(function(old){
var s=document.createElement('script');
for(var i=0;i<old.attributes.length;i++)s.setAttribute(old.attributes[i].name,old.attributes[i].value);
s.textContent=old.textContent; old.parentNode.replaceChild(s,old);
});
render();
}
function setKb(c){kbMap={};(c&&c.items||[]).forEach(function(i){var v=i.properties&&i.properties.__kaching_bundles;if(v)kbMap[i.key]=v;});}
function loadKb(){return fetch(R+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(setKb).catch(function(){});}
function refresh(){
var sec=fetch(R+'?sections='+SEC,{credentials:'same-origin'}).then(function(r){return r.json();});
return Promise.all([sec,loadKb()]).then(function(a){applySection(a[0][SEC]);}).catch(function(){});
}
function busy(on){root.classList.toggle('is-busy',!!on);}
function post(url,payload){
busy(true);
return fetch(R+url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(Object.assign({sections:SEC},payload))})
.then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
.then(function(res){
if(res.j&&res.j.sections&&res.j.sections[SEC]&&res.j.token){setKb(res.j);applySection(res.j.sections[SEC]);return res;}
return refresh().then(function(){return res;});
})
.finally(function(){busy(false);});
}
function open(){root.classList.add('is-open');root.setAttribute('aria-hidden','false');document.documentElement.classList.add('bl-cd-lock');startTimer();}
function close(){root.classList.remove('is-open');root.setAttribute('aria-hidden','true');document.documentElement.classList.remove('bl-cd-lock');}
window.BlCart={open:open,close:close,refresh:refresh};
var tInt=null;
function startTimer(){
if(tInt)return;
var KEY='bl_cd_timer_end', end=0;
try{end=parseInt(sessionStorage.getItem(KEY)||'0',10);}catch(e){}
function tick(){
var now=Date.now();
if(!end||end<=now){end=now+10*60*1000;try{sessionStorage.setItem(KEY,String(end));}catch(e){}}
var s=Math.max(0,Math.round((end-now)/1000)), m=Math.floor(s/60), r=s%60;
var el=document.getElementById('bl-cd-timer'); if(el)el.textContent=(m<10?'0':'')+m+':'+(r<10?'0':'')+r;
}
tick(); tInt=setInterval(tick,1000);
}
root.addEventListener('click',function(e){
var t=e.target.closest('[data-bl-close],[data-bl-rm],[data-bl-q],[data-bl-tog],[data-bl-add],[data-bl-nav],[data-bl-exp],[data-bl-up]');
if(!t)return;
if(t.hasAttribute('data-bl-close')){close();return;}
if(t.hasAttribute('data-bl-up')){upgrade(t.getAttribute('data-bl-up'));return;}
if(t.hasAttribute('data-bl-exp')){t.parentNode.classList.toggle('is-open');return;}
if(t.hasAttribute('data-bl-tog')){var id=t.getAttribute('data-bl-tog');hideSub[id]=!hideSub[id];render();return;}
if(t.hasAttribute('data-bl-nav')){var tr=body.querySelector('.bl-cd__track');if(tr){tr.scrollBy({left:tr.clientWidth*parseInt(t.getAttribute('data-bl-nav'),10),behavior:'smooth'});}return;}
if(t.hasAttribute('data-bl-rm')){var u={};t.getAttribute('data-bl-rm').split(',').forEach(function(k){u[k]=0;});post('cart/update.js',{updates:u});return;}
if(t.hasAttribute('data-bl-q')){post('cart/change.js',{id:t.getAttribute('data-bl-q'),quantity:Math.max(0,parseInt(t.getAttribute('data-n'),10))});return;}
if(t.hasAttribute('data-bl-add')){t.disabled=true;t.textContent='Adding...';post('cart/add.js',{items:[{id:parseInt(t.getAttribute('data-bl-add'),10),quantity:1}]});return;}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('is-open'))close();});
document.addEventListener('click',function(e){
var t=e.target.closest&&e.target.closest('[data-testid="cart-drawer-trigger"], a.action__cart, a[href="'+R+'cart"], a[href="/cart"]');
if(!t||root.contains(t))return;
if(/\/cart\/?$/.test(location.pathname))return;
e.preventDefault();e.stopImmediatePropagation();
open();refresh();
},true);
document.addEventListener('submit',function(e){
var f=e.target;
if(!(f instanceof HTMLFormElement))return;
var a=f.getAttribute('action')||'';
if(a.indexOf('/cart/add')===-1)return;
if(f.closest('product-form-component'))return; // theme forms handle themselves, we listen to cart:update
e.preventDefault();e.stopImmediatePropagation();
var btn=e.submitter||f.querySelector('[type="submit"]');
if(btn){btn.setAttribute('aria-busy','true');btn.style.opacity='.7';}
var fd=new FormData(f);
fetch(R+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:fd})
.then(function(r){
if(!r.ok){return r.json().catch(function(){return {};}).then(function(j){throw j;});}
return refresh().then(open);
})
.catch(function(err){
open();refresh().then(function(){
var msg=(err&&(err.description||err.message))||'Something went wrong, please try again.';
body.insertAdjacentHTML('afterbegin','<p class="bl-cd__err">'+esc(msg)+'</p>');
});
})
.finally(function(){if(btn){btn.removeAttribute('aria-busy');btn.style.opacity='';}});
},true);
document.addEventListener('cart:update',function(e){
var src=e&&e.detail&&e.detail.data&&e.detail.data.source;
refresh().then(function(){ if(src!=='bl-cart')open(); });
});
render();
if(data&&data.count)loadKb().then(render);
})();